module.exports = __webpack_public_path__ + "img/icon-10.a0e5e1f2.png";